import React, { useEffect, useState } from "react";
import HeaderCustom from "../../../components/HeaderCustom";
import { Backdrop, Box, CircularProgress, Container } from "@mui/material";
import SkeletonLoading from "../../../components/SkeletonLoading";
import '../../../styles/AppCss.css'
import { getFiltrarFacturasPendientes } from "../../../api/ApiService";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Delete, Edit } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import FacturasPendientesTableComponent from "./components/FacturasPendientesTableComponent";
import FitrosFacturasPendientesComponent from "./components/FitrosFacturasPendientesComponent";



function FacturasPendientesPage() {
    const [loadingCargar, setLoadingCargar] = useState(false);
    const [loading, setLoading] = useState(false);

    const [dataFacturas, setDataFacturas] = useState([]);


    const [dataClientes, setDataClientes] = useState([]);
    const [clienteSearch, setClienteSearch] = useState('');
    const [clienteSelected, setClienteSelected] = useState(null);
    const [loadingCargarCliente, setLoadingCargarCliente] = useState(false);


    const [fechaInicio, setFechaInicio] = useState(null);
    const [fechaInicioBackend, setFechaInicioBackend] = useState('');

    const [fechaFin, setFechaFin] = useState(null);
    const [fechaFinBackend, setFechaFinBackend] = useState('');

    const [metaPaginacion, setMetaPaginacion] = useState({
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1
    });
    const [perPage, setPerPage] = useState(10);

    const stateToken = useSelector(state => state.reducerGlobal.token);

    let history = useNavigate();


    useEffect(() => {
        setLoading(true);
    }, []);






    const columns = [
        // {
        //     field: 'id',
        //     headerName: 'ID',
        //     flex: 0.5,
        // },
        {
            field: 'usuario_full_name',
            headerName: 'Cliente',
            flex: 1,
            editable: true,
        },
        {
            field: 'fecha_creacion_factura',
            headerName: 'Creado el',
            flex: 1,
            editable: true,
        },
        {
            field: 'fecha_format',
            headerName: 'Observación',
            flex: 1,
            editable: true,
        },
        {
            field: 'local_nombre',
            headerName: 'Foto',
            flex: 1,
            editable: true,
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Acciones',
            flex: 1,
            cellClassName: 'actions',
            getActions: ({ id, row }) => {

                return [
                    <GridActionsCellItem
                        icon={<Edit />}
                        label="Edit"
                        className="textPrimary"
                        onClick={() => {
                            handleEditClick(id, row);
                        }}
                        color="inherit"
                    />,

                ];
            },
        },
    ];













    //============================================= filtros ==========================================



    //=============================================funcion para listar los cupones por fecha desde factura
    const handleFiltrarFechaDesdeFacturaApi = (fechaInicioBusqueda) => {
        setLoadingCargar(true);

        getFiltrarFacturasPendientes(
            fechaInicioBusqueda,
            fechaFinBackend === "" ? "" : fechaFinBackend,
            clienteSelected?.id === undefined ? "" : clienteSelected?.id,
            stateToken?.access_token
        ).then((response) => {
            // console.log("response-getFiltrarFacturas", response?.data);
            setLoadingCargar(false);
            if (response.data.length > 0) {
                setDataFacturas(response.data);

                setLoading(true);
            } else {
                setDataFacturas([]);
                setLoading(true);
            }
        })
            .catch((error) => {
                console.log("error-getFiltrarFacturas", error);
                setLoadingCargar(false);

                setDataFacturas([]);
                setLoading(true);
            });
    };


    //=============================================funcion para listar los cupones por fecha hasta factura
    const handleFiltrarFechaHastaFacturaApi = (fechaHastaBusqueda) => {
        setLoadingCargar(true);

        getFiltrarFacturasPendientes(
            fechaInicioBackend === "" ? "" : fechaInicioBackend,
            fechaHastaBusqueda,
            clienteSelected?.id === undefined ? "" : clienteSelected?.id,
            stateToken?.access_token
        ).then((response) => {
            // console.log("response-getFiltrarFacturas", response?.data);
            setLoadingCargar(false);
            if (response.data.length > 0) {
                setDataFacturas(response.data);
                setLoading(true);
            } else {
                setDataFacturas([]);
                setLoading(true);
            }
        })
            .catch((error) => {
                console.log("error-getFiltrarFacturas", error);
                setLoadingCargar(false);

                setDataFacturas([]);
                setLoading(true);
            });
    };



    //=============================================funcion para listar los cupones por nombre del cliente
    const handleFiltrarNameClienteApi = (nameClienteBusqueda) => {
        setLoadingCargar(true);

        getFiltrarFacturasPendientes(
            fechaInicioBackend === "" ? "" : fechaInicioBackend,
            fechaFinBackend === "" ? "" : fechaFinBackend,
            nameClienteBusqueda,
            stateToken?.access_token
        ).then((response) => {
            // console.log("response-getUsuarios", response?.data);
            setLoadingCargar(false);
            if (response.data.length > 0) {
                setDataFacturas(response.data);
                setLoading(true);
            } else {
                setDataFacturas([]);
                setLoading(true);
            }
        })
            .catch((error) => {
                console.log("error-getUgetFiltrarCuponessuarios", error);
                setLoadingCargar(false);

                setDataFacturas([]);
                setLoading(true);
            });
    };





















    //=============================================funcion para editar
    const handleEditClick = (id, row) => {
        console.log('Edit', id);
        // history(`/app/admin/cupon-detalle/${id}`);
        // history('/app/admin/cupon-editar', {
        //     state: { data: data }
        // });
    };


    //=============================================funcion para eliminar
    const handleDeleteClick = (id) => () => {
        console.log('Delete', id);
        setDataFacturas(dataFacturas.filter((row) => row.id !== id));
    }




    //=============================================funcion para seleccionar la fecha inicio
    const handleFechaInicio = (event) => {
        // console.log("event", event);
        setFechaInicio(event);

        //obtener la fecha en formato YYYY-MM-DD
        let fecha = event.toISOString().split('T')[0];
        setFechaInicioBackend(fecha);

        //llamar a la funcion para filtrar por fecha inicio
        setTimeout(() => {
            handleFiltrarFechaDesdeFacturaApi(fecha);
        }, 1000);
    };








    //=============================================funcion para seleccionar la fecha fin
    const handleFechaFin = (event) => {
        console.log("event", event);
        setFechaFin(event);

        //obtener la fecha en formato YYYY-MM-DD
        let fecha = event.toISOString().split('T')[0];
        console.log("fecha", fecha);
        setFechaFinBackend(fecha);

        //llamar a la funcion para filtrar por fecha fin
        setTimeout(() => {
            handleFiltrarFechaHastaFacturaApi(fecha);
        }, 1000);
    };






    //=============================================funcion para buscar el nombre del cliente
    const handleNameClienteSearch = (e) => {
        setClienteSearch(e);
    };

    //=========================================================funcion para seleccionar el nombre del cliente
    const handleClienteSelected = (value) => {
        console.log("value-handleClienteSelected##########>>> ", value);
        setClienteSelected(value);
        if (value?.id !== undefined) {
            setTimeout(() => {
                handleFiltrarNameClienteApi(value?.id);
            }, 1000);
        }
    };


    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
    };





    //============================================================ funcion para filtrar por estado y nombre
    const handleApiFiltrarEventos = (page = 1) => {

        // let body = {
        //     page: page,
        //     per_page: perPage,
        //     estado: statusFilter,
        //     titulo: searchFilter
        // };
        // // console.log("body-handleApiFiltrarLocales", body);


        // setLoadingCargar(true);

        // getFiltrarFacturasPendientes(stateToken?.access_token, body)
        //     .then(response => {
        //         // console.log("response==>", response);

        //         setLoadingCargar(false);
        //         // setMetaPaginacion(response.meta);

        //         if (response.data.length > 0) {
        //             setDataFacturas(response.data);
        //             setLoading(true);
        //         } else {
        //             setDataFacturas([]);
        //             setLoading(true);
        //         }

        //         setMetaPaginacion({
        //             current_page: response?.current_page,
        //             per_page: response?.per_page,
        //             total: response?.total,
        //             last_page: response?.last_page
        //         });


        //     })
        //     .catch(error => {
        //         console.log("error==>", error);
        //         setDataFacturas([]);
        //         setLoading(true);
        //         setLoadingCargar(false);
        //     })
    };



    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-6">
                {loading ? (
                    <div>
                        <FitrosFacturasPendientesComponent
                            title={'Facturas Pendientes'}



                            fechaInicio={fechaInicio}
                            handleFechaInicio={handleFechaInicio}

                            fechaFin={fechaFin}
                            handleFechaFin={handleFechaFin}

                            clienteSelected={clienteSelected}
                            loadingCargarCliente={loadingCargarCliente}
                            dataClientes={dataClientes}
                            handleNameClienteSearch={handleNameClienteSearch}
                            handleClienteSelected={handleClienteSelected}

                        />

                        <div>
                            <FacturasPendientesTableComponent
                                data={dataFacturas}
                                metaPaginacion={metaPaginacion}
                                onPageChange={handleApiFiltrarEventos}
                                perPage={perPage}
                                onPerPageChange={handlePerPageChange}
                                handleEditarItem={handleEditClick}
                            // handleOpenModalDeleteEvento={handleOpenModalDeleteEvento}
                            />
                        </div>

                        {/* <div style={{
                            backgroundColor: PaletaColor.BLANCO,
                            borderRadius: Padding.P1,
                            padding: Padding.P3,
                        }}>
                            <Box sx={{ width: '100%' }}>
                                <DataGrid
                                    rows={dataFacturas}
                                    columns={columns}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 10,
                                            },
                                        },
                                    }}
                                    pageSizeOptions={[5, 10, 25]}
                                    // checkboxSelection
                                    disableRowSelectionOnClick
                                />
                            </Box>
                        </div> */}
                    </div>
                ) : (
                    <div className="bg-white rounded-xl shadow-md p-8">
                        <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                        <div className="space-y-4">
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-24 bg-gray-200 rounded animate-pulse" />
                        </div>
                    </div>
                )}


                <Backdrop open={loadingCargar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        </HeaderCustom>
    );
}

export default FacturasPendientesPage;